/**
 * Ambient, always-visible reminder of which environment this build is
 * pointed at -- the other half of the axiosConfig fix. That fix stops a
 * misconfigured build from silently talking to production at the code
 * level; this lets a person glance at the screen and know which
 * environment they're looking at. Neither replaces the other.
 *
 * Renders nothing in production: REACT_APP_ENV is set only for
 * non-production builds -- deploy-stg.yml already set it
 * (`REACT_APP_ENV=staging`) for this exact purpose, but nothing read it
 * until now. `.env.example` sets it too, so a local dev build (the actual
 * scenario that caused the incident this indicator exists for) shows it as
 * well, not just a deployed staging build. A third environment (dev, QA)
 * needs only its own value for this same var -- nothing here is
 * staging-specific.
 *
 * Amber, not red: this isn't an error state, just a different one. Reuses
 * statusPalette's existing caution color rather than a new one -- same
 * principle as the interview badge and role tag tonight.
 */

import { memo } from 'react';
import { Tag } from 'antd';
import { statusPalette } from '../../../smallApps/jobs/utils/statusPalette';
import styles from './index.module.css';

export const EnvironmentTag = memo(() => {
  const env = process.env.REACT_APP_ENV;

  if (!env) return null;

  const label = env.toUpperCase();

  return (
    <Tag
      className={styles.tag}
      style={{
        color: statusPalette.caution,
        background: statusPalette.cautionBg,
        borderColor: 'transparent',
      }}
    >
      {label}
    </Tag>
  );
});

EnvironmentTag.displayName = 'EnvironmentTag';

export default EnvironmentTag;
